import axios from "axios";
import defaultAxiosInstance from "./axiosInstance";
import useIsLoadingStore from "store/isLoading";
import useAlertStore from "store/alert";

export type IResponse =
  | {
      status: {
        code: number;
        dtlCode: string;
        message: string;
      };
      data: any;
    }
  | any;

interface IProps {
  method: "post" | "get";
  url: string;
  data?: object;
}

const api = async ({ method, url, data }: IProps) => {
  // 페이이지 로딩 : 로그아웃 제외
  const { onSetAlert } = useAlertStore.getState();
  const { showLoading, hideLoading } = useIsLoadingStore.getState();
  if (!url.includes("logout")) {
    showLoading();
  }
  onSetAlert({
    isOpen: false,
    inner: "",
  });

  try {
    axios.defaults.withCredentials = true;
    const response = await defaultAxiosInstance({
      method,
      url: url,
      data,
    });

    const res: IResponse = response.data;

    return res;
  } catch (error: any) {
    console.error("error", error);
    // setTimeout(() => {
    //   hideLoading();
    // }, 200);

    onSetAlert({
      isOpen: true,
      inner: error?.message,
    });
  } finally {
    hideLoading();
  }
};

export default api;
